export const DeleteNoteModal = ({ noteToDelete, onConfirm, onCancel }) => {
  if (!noteToDelete) return null;

  return (
    <div style={{
      position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.6)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      zIndex: 1301
    }}>
      <div style={{
        backgroundColor: 'white', borderRadius: '16px', padding: '2rem',
        maxWidth: '500px', width: '90%',
        boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)'
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '1.5rem' }}>
          <div style={{
            width: '48px', height: '48px', borderRadius: '50%',
            backgroundColor: '#fee', display: 'flex', alignItems: 'center', justifyContent: 'center'
          }}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" stroke="#e53e3e" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>
          <h2 style={{ margin: 0, color: '#2d3748', fontSize: '1.5rem', fontWeight: '700' }}>Delete Note</h2>
        </div>

        <p style={{ color: '#4a5568', fontSize: '1rem', lineHeight: '1.6', marginBottom: '1.5rem' }}>
          Are you sure you want to delete this SOAP note? This action cannot be undone.
        </p>

        <div style={{
          backgroundColor: '#f7fafc', borderRadius: '8px', padding: '1rem',
          marginBottom: '2rem', border: '1px solid #e2e8f0'
        }}>
          <div style={{ marginBottom: '0.5rem' }}>
            <strong style={{ color: '#2d3748' }}>Patient:</strong>{' '}
            <span style={{ color: '#4a5568' }}>{noteToDelete.patientName}</span>
          </div>
          <div style={{ marginBottom: '0.5rem' }}>
            <strong style={{ color: '#2d3748' }}>Appointment Date:</strong>{' '}
            <span style={{ color: '#4a5568' }}>{noteToDelete.appointmentDate}</span>
          </div>
          {noteToDelete.createdAt && (
            <div>
              <strong style={{ color: '#2d3748' }}>Created:</strong>{' '}
              <span style={{ color: '#4a5568' }}>{new Date(noteToDelete.createdAt).toLocaleString()}</span>
            </div>
          )}
        </div>

        <div style={{ display: 'flex', gap: '1rem', justifyContent: 'flex-end' }}>
          <button
            onClick={onCancel}
            style={{
              padding: '0.75rem 1.5rem', backgroundColor: '#e2e8f0', color: '#2d3748',
              border: 'none', borderRadius: '8px', fontSize: '1rem', fontWeight: '600',
              cursor: 'pointer', transition: 'background-color 0.2s'
            }}
            onMouseEnter={(e) => e.target.style.backgroundColor = '#cbd5e0'}
            onMouseLeave={(e) => e.target.style.backgroundColor = '#e2e8f0'}
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            style={{
              padding: '0.75rem 1.5rem', backgroundColor: '#e53e3e', color: 'white',
              border: 'none', borderRadius: '8px', fontSize: '1rem', fontWeight: '600',
              cursor: 'pointer', transition: 'background-color 0.2s'
            }}
            onMouseEnter={(e) => e.target.style.backgroundColor = '#c53030'}
            onMouseLeave={(e) => e.target.style.backgroundColor = '#e53e3e'}
          >
            Delete Note
          </button>
        </div>
      </div>
    </div>
  );
};
